import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {RegisterNewProductsBrComponent} from './register-new-products-br.component';

const routes: Routes = [
  {path: '', component: RegisterNewProductsBrComponent},
  {path: ':id', component: RegisterNewProductsBrComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RegisterNewProductsBrRoutingModule { }
